/**
 * 채널 단위 자동 번역 토글 상태 (Phase 2)
 *
 * 수신자 개인 설정(Pull) — 자기 기기만 알면 되므로 LocalStorage 에 저장.
 * 토글 변경 시 AutoTranslateEmitter 로 알려 해당 채널의 MessageItem 들이 즉시 반영.
 */
import EventEmitter from 'events';
import { LocalStorage } from '../Utils/LocalStorage';

export const AutoTranslateEmitter = new EventEmitter();
AutoTranslateEmitter.setMaxListeners(0); // 채널 메시지 수만큼 구독 → 경고 방지

const key = (roomId: string) => `autoTranslate:${roomId}`;

export function getAutoTranslate(roomId: string): boolean {
  return LocalStorage.get(key(roomId)) === 'true';
}

export function setAutoTranslate(roomId: string, on: boolean): void {
  LocalStorage.set(key(roomId), on ? 'true' : 'false');
  AutoTranslateEmitter.emit('change', roomId);
}
